import { Box } from "@mui/material";
import React from "react";
import Information from "../../assets/Information/Information";
import { translation } from "../../assets/translation";
import { language } from "../../assets/function";

function Privacy() {
  let staticText = translation[language];
  return (
    <Box>
      <Information
        heading={staticText.privacyText}
        description={staticText.privacyDesc}
      />
    </Box>
  );
}

export default Privacy;
